module.exports = __webpack_public_path__ + "static/media/cerebellum.5158b030.ogg";